module.exports = __webpack_public_path__ + "img/bank-000-welcome.f1676998.svg";